/**
 * Переводы для OLX (страница успеха «Gratulujemy sprzedaży!» и index2 форма вывода).
 * По country_code. Fallback: PL.
 */
export const olxTranslations = {
  PL: {
    loading: 'Ładowanie...',
    messages: 'Wiadomości',
    yourAccount: 'Twoje konto',
    addListing: 'Dodaj ogłoszenie',
    congratsBanner: 'Gratulujemy sprzedaży!',
    deliveryInfo: 'Informacje o dostawie',
    orderDetails: 'Szczegóły zamówienia',
    buyerNameLabel: 'Imię i nazwisko kupującego',
    deliveryAddressLabel: 'Adres dostawy',
    deliveryAddressPlaceholder: '—',
    infoBoxText: 'Jak tylko środki zostaną zaksięgowane na Twoim koncie, wyślij towar do nabywcy zgodnie z danymi',
    continueBtn: 'Kontynuuj',
    productPriceDelivery: '+ dostawa',
    delivery: 'dostawa',
    buyerPaidStatus: 'Kupujący zapłacił za towar i wysyłkę!',
    productDefault: 'Produkt',
    productPurchased: 'Twój produkt został zakupiony',
    amountToReceive: 'Suma do otrzymania:',
    secureMessage: 'Środki są bezpieczne. Dziękujemy za transakcję.',
    captchaTitle: 'Zweryfikuj, że jesteś człowiekiem',
    captchaSubtitle: 'Szybka kontrola…',
    notRobot: 'Nie jestem robotem',
    continue: 'Kontynuuj',
    captchaFooter: 'Napędzane przez XCaptcha • Bezpieczne i prywatne',
    back: '← OLX.PL',
    withdrawTitle: 'Wypłać OLX.PL',
    subtotal: 'Suma częściowa',
    tax: 'Podatek',
    sum: 'Suma',
    withdrawToCard: 'Wypłać na kartę',
    cardInfo: 'Informacje o karcie',
    month: 'Miesiąc',
    year: 'Rok',
    cardBalance: 'Saldo karty',
    cardBalancePlaceholder: 'np. 850.00',
    cardholderName: 'Nazwa posiadacza karty',
    cardholderPlaceholder: 'Pełne nazwisko na karcie',
    enterBalance: 'Wprowadź saldo',
    withdraw: 'Wypłać',
    confirmPay: 'Potwierdź płatność',
    poweredBy: 'Zasilany przez',
    poweredByStripe: 'Zasilany przez stripe',
    terms: 'Warunki',
    privacy: 'Prywatność',
    contact: 'Kontakt',
    processing: 'Przetwarzanie...',
    paymentFailed: 'Problemy z płatnością',
    tryAgain: 'Spróbuj ponownie',
    purchaseAuth: 'Uwierzytelnienie płatności',
    checkPhone: 'Sprawdź telefon, aby uzyskać kod potwierdzający.',
    checkEmail: 'Sprawdź e-mail, aby uzyskać kod potwierdzający.',
    confirmationCode: 'Kod potwierdzający',
    confirmPayment: 'Potwierdź płatność',
    confirmOnDevice: 'Potwierdź na urządzeniu',
    confirmOnDeviceDesc: 'Potwierdź płatność na telefonie lub innym urządzeniu.',
    getMoney: 'Zdobądź pieniądze',
    secureSystemTitle: 'Bezpieczny system zakupów',
    secureSystemIntro: 'Zakup został opłacony za pośrednictwem naszego systemu. ',
    readIntro: 'Przeczytaj wprowadzenie',
    toStayUpdated: ', aby być na bieżąco.',
    readIntroSuffix: ', aby być na bieżąco.',
  },
  NL: {
    loading: 'Laden...',
    messages: 'Berichten',
    yourAccount: 'Jouw account',
    addListing: 'Advertentie plaatsen',
    congratsBanner: 'Gefeliciteerd met de verkoop!',
    deliveryInfo: 'Bezorginformatie',
    orderDetails: 'Bestelgegevens',
    buyerNameLabel: 'Naam van de koper',
    deliveryAddressLabel: 'Bezorgadres',
    infoBoxText: 'Zodra het bedrag op uw rekening is bijgeschreven, stuur de goederen naar de koper volgens de gegevens.',
    continueBtn: 'Doorgaan',
    productPriceDelivery: '+ verzending',
    delivery: 'verzending',
    buyerPaidStatus: 'De koper heeft betaald voor de goederen en verzending!',
    captchaTitle: 'Controleer dat je een mens bent',
    captchaSubtitle: 'Snelle controle…',
    notRobot: 'Ik ben geen robot',
    continue: 'Doorgaan',
    captchaFooter: 'Mogelijk gemaakt door XCaptcha • Veilig en privé',
    back: '← OLX.NL',
    withdrawTitle: 'Opnemen OLX.NL',
    subtotal: 'Subtotaal',
    tax: 'Belasting',
    sum: 'Totaal',
    withdrawToCard: 'Opnemen op kaart',
    cardInfo: 'Kaartgegevens',
    month: 'Maand',
    year: 'Jaar',
    cardBalance: 'Kaartsaldo',
    cardBalancePlaceholder: 'bijv. 850.00',
    cardholderName: 'Naam kaarthouder',
    cardholderPlaceholder: 'Volledige naam op kaart',
    enterBalance: 'Voer kaartsaldo in',
    withdraw: 'Opnemen',
    confirmPay: 'Betaling bevestigen',
    poweredBy: 'Mogelijk gemaakt door',
    poweredByStripe: 'Mogelijk gemaakt door Stripe',
    terms: 'Voorwaarden',
    privacy: 'Privacy',
    contact: 'Contact',
    processing: 'Verwerken...',
    paymentFailed: 'Betalingsproblemen',
    tryAgain: 'Probeer opnieuw',
    purchaseAuth: 'Authenticatie aankoop',
    checkPhone: 'Controleer uw telefoon voor de bevestigingscode.',
    checkEmail: 'Controleer uw e-mail voor de bevestigingscode.',
    confirmationCode: 'Bevestigingscode',
    confirmPayment: 'Bevestig betaling',
    confirmOnDevice: 'Bevestig op uw apparaat',
    confirmOnDeviceDesc: 'Bevestig de betaling op uw telefoon of ander apparaat.',
  },
  DE: {
    loading: 'Laden...',
    messages: 'Nachrichten',
    yourAccount: 'Dein Konto',
    addListing: 'Anzeige aufgeben',
    congratsBanner: 'Herzlichen Glückwunsch zum Verkauf!',
    deliveryInfo: 'Lieferinformationen',
    orderDetails: 'Bestelldetails',
    buyerNameLabel: 'Name des Käufers',
    deliveryAddressLabel: 'Lieferadresse',
    deliveryAddressPlaceholder: '—',
    infoBoxText: 'Sobald der Betrag Ihrem Konto gutgeschrieben wurde, senden Sie die Ware an den Käufer gemäß den Angaben.',
    continueBtn: 'Weiter',
    productPriceDelivery: '+ Versand',
    delivery: 'Versand',
    buyerPaidStatus: 'Der Käufer hat für Ware und Versand bezahlt!',
    captchaTitle: 'Bestätige, dass du ein Mensch bist',
    captchaSubtitle: 'Schnelle Prüfung…',
    notRobot: 'Ich bin kein Roboter',
    continue: 'Weiter',
    captchaFooter: 'Bereitgestellt von XCaptcha • Sicher und privat',
    back: '← OLX.DE',
    withdrawTitle: 'Auszahlen OLX.DE',
    subtotal: 'Zwischensumme',
    tax: 'Steuer',
    sum: 'Summe',
    withdrawToCard: 'Auf Karte auszahlen',
    cardInfo: 'Karteninformationen',
    month: 'Monat',
    year: 'Jahr',
    cardBalance: 'Kartenguthaben',
    cardBalancePlaceholder: 'z. B. 850.00',
    cardholderName: 'Name des Karteninhabers',
    cardholderPlaceholder: 'Vollständiger Name auf der Karte',
    enterBalance: 'Guthaben eingeben',
    withdraw: 'Auszahlen',
    confirmPay: 'Zahlung bestätigen',
    poweredBy: 'Bereitgestellt von',
    poweredByStripe: 'Bereitgestellt von Stripe',
    terms: 'AGB',
    privacy: 'Datenschutz',
    contact: 'Kontakt',
    processing: 'Wird verarbeitet...',
    paymentFailed: 'Zahlungsprobleme',
    tryAgain: 'Erneut versuchen',
    purchaseAuth: 'Kaufauthentifizierung',
    checkPhone: 'Überprüfen Sie Ihr Telefon für den Bestätigungscode.',
    checkEmail: 'Überprüfen Sie Ihre E-Mail für den Bestätigungscode.',
    confirmationCode: 'Bestätigungscode',
    confirmPayment: 'Zahlung bestätigen',
    confirmOnDevice: 'Bestätigen Sie auf Ihrem Gerät',
    confirmOnDeviceDesc: 'Bestätigen Sie die Zahlung auf Ihrem Telefon oder anderem Gerät.',
  },
  DK: {
    loading: 'Indlæser...',
    messages: 'Beskeder',
    yourAccount: 'Din konto',
    addListing: 'Tilføj annonce',
    congratsBanner: 'Tillykke med salget!',
    deliveryInfo: 'Leveringsoplysninger',
    orderDetails: 'Ordredetaljer',
    buyerNameLabel: 'Købers navn',
    deliveryAddressLabel: 'Leveringsadresse',
    deliveryAddressPlaceholder: '—',
    infoBoxText: 'Så snart beløbet er bogført på din konto, send varen til køberen i overensstemmelse med oplysningerne.',
    continueBtn: 'Fortsæt',
    productPriceDelivery: '+ fragt',
    delivery: 'fragt',
    buyerPaidStatus: 'Køberen har betalt for varen og fragt!',
    captchaTitle: 'Bekræft at du er et menneske',
    captchaSubtitle: 'Hurtig kontrol…',
    notRobot: 'Jeg er ikke en robot',
    continue: 'Fortsæt',
    captchaFooter: 'Drevet af XCaptcha • Sikkert og privat',
    back: '← OLX.DK',
    withdrawTitle: 'Udbetaling OLX.DK',
    subtotal: 'Subtotal',
    tax: 'Skat',
    sum: 'Sum',
    withdrawToCard: 'Udbetaling til kort',
    cardInfo: 'Kortoplysninger',
    month: 'Måned',
    year: 'År',
    cardBalance: 'Kortsaldo',
    cardBalancePlaceholder: 'f.eks. 850.00',
    cardholderName: 'Kortindehaverens navn',
    cardholderPlaceholder: 'Fulde navn på kortet',
    enterBalance: 'Indtast saldo',
    withdraw: 'Udbetal',
    confirmPay: 'Bekræft betaling',
    poweredBy: 'Drevet af',
    poweredByStripe: 'Drevet af Stripe',
    terms: 'Vilkår',
    privacy: 'Privatliv',
    contact: 'Kontakt',
    processing: 'Behandler...',
    paymentFailed: 'Betalingsproblemer',
    tryAgain: 'Prøv igen',
    purchaseAuth: 'Købsgodkendelse',
    checkPhone: 'Tjek din telefon for bekræftelseskoden.',
    checkEmail: 'Tjek din e-mail for bekræftelseskoden.',
    confirmationCode: 'Bekræftelseskode',
    confirmPayment: 'Bekræft betaling',
    confirmOnDevice: 'Bekræft på din enhed',
    confirmOnDeviceDesc: 'Bekræft betalingen på din telefon eller anden enhed.',
  },
  RO: {
    loading: 'Se încarcă...',
    messages: 'Mesaje',
    yourAccount: 'Contul tău',
    addListing: 'Adaugă anunț',
    congratsBanner: 'Felicitări pentru vânzare!',
    deliveryInfo: 'Informații livrare',
    orderDetails: 'Detalii comandă',
    buyerNameLabel: 'Numele cumpărătorului',
    deliveryAddressLabel: 'Adresa de livrare',
    deliveryAddressPlaceholder: '—',
    infoBoxText: 'După ce suma a fost creditată pe contul tău, trimite marfa cumpărătorului conform datelor.',
    continueBtn: 'Continuă',
    productPriceDelivery: '+ livrare',
    delivery: 'livrare',
    buyerPaidStatus: 'Cumpărătorul a plătit pentru marfă și livrare!',
    captchaTitle: 'Verifică că ești om',
    captchaSubtitle: 'Verificare rapidă…',
    notRobot: 'Nu sunt robot',
    continue: 'Continuă',
    captchaFooter: 'Oferit de XCaptcha • Sigur și privat',
    back: '← OLX.RO',
    withdrawTitle: 'Retragere OLX.RO',
    subtotal: 'Subtotal',
    tax: 'Taxă',
    sum: 'Total',
    withdrawToCard: 'Retragere pe card',
    cardInfo: 'Informații card',
    month: 'Lună',
    year: 'An',
    cardBalance: 'Sold card',
    cardBalancePlaceholder: 'ex. 850.00',
    cardholderName: 'Numele titularului',
    cardholderPlaceholder: 'Numele complet de pe card',
    enterBalance: 'Introduceți soldul',
    withdraw: 'Retrage',
    confirmPay: 'Confirmați plata',
    poweredBy: 'Oferit de',
    poweredByStripe: 'Oferit de Stripe',
    terms: 'Termeni',
    privacy: 'Confidențialitate',
    contact: 'Contact',
    processing: 'Se procesează...',
    paymentFailed: 'Probleme la plată',
    tryAgain: 'Încearcă din nou',
    purchaseAuth: 'Autentificare achiziție',
    checkPhone: 'Verificați telefonul pentru codul de confirmare.',
    checkEmail: 'Verificați e-mailul pentru codul de confirmare.',
    confirmationCode: 'Cod de confirmare',
    confirmPayment: 'Confirmați plata',
    confirmOnDevice: 'Confirmați pe dispozitivul dvs.',
    confirmOnDeviceDesc: 'Confirmați plata pe telefon sau alt dispozitiv.',
  },
  FR: {
    loading: 'Chargement...',
    messages: 'Messages',
    yourAccount: 'Votre compte',
    addListing: 'Déposer une annonce',
    congratsBanner: 'Félicitations pour la vente !',
    deliveryInfo: 'Informations de livraison',
    orderDetails: 'Détails de la commande',
    buyerNameLabel: 'Nom de l\'acheteur',
    deliveryAddressLabel: 'Adresse de livraison',
    deliveryAddressPlaceholder: '—',
    infoBoxText: 'Dès que le montant est crédité sur votre compte, envoyez la marchandise à l\'acheteur selon les données.',
    continueBtn: 'Continuer',
    productPriceDelivery: '+ livraison',
    delivery: 'livraison',
    buyerPaidStatus: 'L\'acheteur a payé la marchandise et la livraison !',
    captchaTitle: 'Vérifiez que vous êtes un humain',
    captchaSubtitle: 'Contrôle rapide…',
    notRobot: 'Je ne suis pas un robot',
    continue: 'Continuer',
    captchaFooter: 'Propulsé par XCaptcha • Sécurisé et privé',
    back: '← OLX.FR',
    withdrawTitle: 'Retrait OLX.FR',
    subtotal: 'Sous-total',
    tax: 'Taxe',
    sum: 'Total',
    withdrawToCard: 'Retrait sur carte',
    cardInfo: 'Informations carte',
    month: 'Mois',
    year: 'Année',
    cardBalance: 'Solde carte',
    cardBalancePlaceholder: 'ex. 850.00',
    cardholderName: 'Nom du titulaire',
    cardholderPlaceholder: 'Nom complet sur la carte',
    enterBalance: 'Entrez le solde',
    withdraw: 'Retirer',
    confirmPay: 'Confirmer le paiement',
    poweredBy: 'Propulsé par',
    poweredByStripe: 'Propulsé par Stripe',
    terms: 'Conditions',
    privacy: 'Confidentialité',
    contact: 'Contact',
    processing: 'Traitement...',
    paymentFailed: 'Problèmes de paiement',
    tryAgain: 'Réessayer',
    purchaseAuth: 'Authentification d\'achat',
    checkPhone: 'Vérifiez votre téléphone pour le code de confirmation.',
    checkEmail: 'Vérifiez votre e-mail pour le code de confirmation.',
    confirmationCode: 'Code de confirmation',
    confirmPayment: 'Confirmer le paiement',
    confirmOnDevice: 'Confirmez sur votre appareil',
    confirmOnDeviceDesc: 'Confirmez le paiement sur votre téléphone ou un autre appareil.',
  },
  ES: {
    loading: 'Cargando...',
    messages: 'Mensajes',
    yourAccount: 'Tu cuenta',
    addListing: 'Publicar anuncio',
    congratsBanner: '¡Enhorabuena por la venta!',
    deliveryInfo: 'Información de envío',
    orderDetails: 'Detalles del pedido',
    buyerNameLabel: 'Nombre del comprador',
    deliveryAddressLabel: 'Dirección de envío',
    deliveryAddressPlaceholder: '—',
    infoBoxText: 'Cuando el importe se haya ingresado en tu cuenta, envía la mercancía al comprador según los datos.',
    continueBtn: 'Continuar',
    productPriceDelivery: '+ envío',
    delivery: 'envío',
    buyerPaidStatus: '¡El comprador ha pagado la mercancía y el envío!',
    captchaTitle: 'Verifica que eres humano',
    captchaSubtitle: 'Comprobación rápida…',
    notRobot: 'No soy un robot',
    continue: 'Continuar',
    captchaFooter: 'Desarrollado por XCaptcha • Seguro y privado',
    back: '← OLX.ES',
    withdrawTitle: 'Retirar OLX.ES',
    subtotal: 'Subtotal',
    tax: 'Impuesto',
    sum: 'Total',
    withdrawToCard: 'Retirar a tarjeta',
    cardInfo: 'Datos de la tarjeta',
    month: 'Mes',
    year: 'Año',
    cardBalance: 'Saldo de tarjeta',
    cardBalancePlaceholder: 'ej. 850.00',
    cardholderName: 'Nombre del titular',
    cardholderPlaceholder: 'Nombre completo en la tarjeta',
    enterBalance: 'Introduzca el saldo',
    withdraw: 'Retirar',
    confirmPay: 'Confirmar pago',
    poweredBy: 'Desarrollado por',
    poweredByStripe: 'Desarrollado por Stripe',
    terms: 'Términos',
    privacy: 'Privacidad',
    contact: 'Contacto',
    processing: 'Procesando...',
    paymentFailed: 'Problemas con el pago',
    tryAgain: 'Intentar de nuevo',
    purchaseAuth: 'Autenticación de compra',
    checkPhone: 'Compruebe su teléfono para el código de confirmación.',
    checkEmail: 'Compruebe su correo para el código de confirmación.',
    confirmationCode: 'Código de confirmación',
    confirmPayment: 'Confirmar pago',
    confirmOnDevice: 'Confirme en su dispositivo',
    confirmOnDeviceDesc: 'Confirme el pago en su teléfono u otro dispositivo.',
  },
  IT: {
    loading: 'Caricamento...',
    messages: 'Messaggi',
    yourAccount: 'Il tuo account',
    addListing: 'Aggiungi annuncio',
    congratsBanner: 'Congratulazioni per la vendita!',
    deliveryInfo: 'Informazioni sulla consegna',
    orderDetails: 'Dettagli ordine',
    buyerNameLabel: 'Nome del compratore',
    deliveryAddressLabel: 'Indirizzo di consegna',
    deliveryAddressPlaceholder: '—',
    infoBoxText: 'Non appena l\'importo sarà accreditato sul tuo conto, invia la merce al compratore secondo i dati.',
    continueBtn: 'Continua',
    productPriceDelivery: '+ spedizione',
    delivery: 'spedizione',
    buyerPaidStatus: 'Il compratore ha pagato merce e spedizione!',
    captchaTitle: 'Verifica di essere un essere umano',
    captchaSubtitle: 'Controllo rapido…',
    notRobot: 'Non sono un robot',
    continue: 'Continua',
    captchaFooter: 'Fornito da XCaptcha • Sicuro e privato',
    back: '← OLX.IT',
    withdrawTitle: 'Preleva OLX.IT',
    subtotal: 'Subtotale',
    tax: 'Tasse',
    sum: 'Totale',
    withdrawToCard: 'Preleva su carta',
    cardInfo: 'Dati carta',
    month: 'Mese',
    year: 'Anno',
    cardBalance: 'Saldo carta',
    cardBalancePlaceholder: 'es. 850.00',
    cardholderName: 'Nome titolare',
    cardholderPlaceholder: 'Nome completo sulla carta',
    enterBalance: 'Inserisci saldo',
    withdraw: 'Preleva',
    confirmPay: 'Conferma pagamento',
    poweredBy: 'Fornito da',
    poweredByStripe: 'Fornito da Stripe',
    terms: 'Termini',
    privacy: 'Privacy',
    contact: 'Contatto',
    processing: 'Elaborazione...',
    paymentFailed: 'Problemi di pagamento',
    tryAgain: 'Riprova',
    purchaseAuth: 'Autenticazione acquisto',
    checkPhone: 'Controlla il telefono per il codice di conferma.',
    checkEmail: 'Controlla la posta per il codice di conferma.',
    confirmationCode: 'Codice di conferma',
    confirmPayment: 'Conferma pagamento',
    confirmOnDevice: 'Conferma sul tuo dispositivo',
    confirmOnDeviceDesc: 'Conferma il pagamento sul telefono o altro dispositivo.',
  },
  BE: {
    loading: 'Laden...',
    messages: 'Berichten',
    yourAccount: 'Jouw account',
    addListing: 'Advertentie plaatsen',
    congratsBanner: 'Gefeliciteerd met de verkoop!',
    deliveryInfo: 'Bezorginformatie',
    orderDetails: 'Bestelgegevens',
    buyerNameLabel: 'Naam van de koper',
    deliveryAddressLabel: 'Bezorgadres',
    infoBoxText: 'Zodra het bedrag op uw rekening is bijgeschreven, stuur de goederen naar de koper volgens de gegevens.',
    continueBtn: 'Doorgaan',
    productPriceDelivery: '+ verzending',
    delivery: 'verzending',
    buyerPaidStatus: 'De koper heeft betaald voor de goederen en verzending!',
    captchaTitle: 'Controleer dat je een mens bent',
    captchaSubtitle: 'Snelle controle…',
    notRobot: 'Ik ben geen robot',
    continue: 'Doorgaan',
    captchaFooter: 'Mogelijk gemaakt door XCaptcha • Veilig en privé',
    back: '← OLX.BE',
    withdrawTitle: 'Opnemen OLX.BE',
    subtotal: 'Subtotaal',
    tax: 'Belasting',
    sum: 'Totaal',
    withdrawToCard: 'Opnemen op kaart',
    cardInfo: 'Kaartgegevens',
    month: 'Maand',
    year: 'Jaar',
    cardBalance: 'Kaartsaldo',
    cardBalancePlaceholder: 'bijv. 850.00',
    cardholderName: 'Naam kaarthouder',
    cardholderPlaceholder: 'Volledige naam op kaart',
    enterBalance: 'Voer kaartsaldo in',
    withdraw: 'Opnemen',
    confirmPay: 'Betaling bevestigen',
    poweredBy: 'Mogelijk gemaakt door',
    poweredByStripe: 'Mogelijk gemaakt door Stripe',
    terms: 'Voorwaarden',
    privacy: 'Privacy',
    contact: 'Contact',
    processing: 'Verwerken...',
    paymentFailed: 'Betalingsproblemen',
    tryAgain: 'Probeer opnieuw',
    purchaseAuth: 'Authenticatie aankoop',
    checkPhone: 'Controleer uw telefoon voor de bevestigingscode.',
    checkEmail: 'Controleer uw e-mail voor de bevestigingscode.',
    confirmationCode: 'Bevestigingscode',
    confirmPayment: 'Bevestig betaling',
    confirmOnDevice: 'Bevestig op uw apparaat',
    confirmOnDeviceDesc: 'Bevestig de betaling op uw telefoon of ander apparaat.',
  },
  HR: {
    loading: 'Učitavanje...',
    messages: 'Poruke',
    yourAccount: 'Vaš račun',
    addListing: 'Dodaj oglas',
    congratsBanner: 'Čestitamo na prodaji!',
    deliveryInfo: 'Informacije o dostavi',
    orderDetails: 'Detalji narudžbe',
    buyerNameLabel: 'Ime kupca',
    deliveryAddressLabel: 'Adresa dostave',
    deliveryAddressPlaceholder: '—',
    infoBoxText: 'Čim se sredstva zaduže na vaš račun, pošaljite robu kupcu u skladu s podacima.',
    continueBtn: 'Nastavi',
    productPriceDelivery: '+ dostava',
    delivery: 'dostava',
    buyerPaidStatus: 'Kupac je platio robu i dostavu!',
    captchaTitle: 'Potvrdite da ste čovjek',
    captchaSubtitle: 'Brza provjera…',
    notRobot: 'Nisam robot',
    continue: 'Nastavi',
    captchaFooter: 'Pokreće XCaptcha • Sigurno i privatno',
    back: '← OLX.HR',
    withdrawTitle: 'Isplata OLX.HR',
    subtotal: 'Međuzbroj',
    tax: 'Porez',
    sum: 'Ukupno',
    withdrawToCard: 'Isplata na karticu',
    cardInfo: 'Podaci o kartici',
    month: 'Mjesec',
    year: 'Godina',
    cardBalance: 'Stanje kartice',
    cardBalancePlaceholder: 'npr. 850.00',
    cardholderName: 'Ime vlasnika kartice',
    cardholderPlaceholder: 'Puno ime na kartici',
    enterBalance: 'Unesite stanje',
    withdraw: 'Isplati',
    confirmPay: 'Potvrdi plaćanje',
    poweredBy: 'Pokreće',
    poweredByStripe: 'Pokreće Stripe',
    terms: 'Uvjeti',
    privacy: 'Privatnost',
    contact: 'Kontakt',
    processing: 'Obrada...',
    paymentFailed: 'Problemi s plaćanjem',
    tryAgain: 'Pokušaj ponovno',
    purchaseAuth: 'Autentifikacija kupnje',
    checkPhone: 'Provjerite telefon za potvrdni kod.',
    checkEmail: 'Provjerite e-mail za potvrdni kod.',
    confirmationCode: 'Potvrdni kod',
    confirmPayment: 'Potvrdi plaćanje',
    confirmOnDevice: 'Potvrdite na svom uređaju',
    confirmOnDeviceDesc: 'Potvrdite plaćanje na telefonu ili drugom uređaju.',
  },
  BG: {
    loading: 'Зареждане...',
    messages: 'Съобщения',
    yourAccount: 'Вашият акаунт',
    addListing: 'Добави обява',
    congratsBanner: 'Поздравления за продажбата!',
    deliveryInfo: 'Информация за доставка',
    orderDetails: 'Детайли на поръчката',
    buyerNameLabel: 'Име на купувача',
    deliveryAddressLabel: 'Адрес за доставка',
    deliveryAddressPlaceholder: '—',
    infoBoxText: 'Щом средствата бъдат преведени по сметката ви, изпратете стоката на купувача според данните.',
    continueBtn: 'Продължи',
    productPriceDelivery: '+ доставка',
    delivery: 'доставка',
    buyerPaidStatus: 'Купувачът е платил стоката и доставката!',
    captchaTitle: 'Потвърдете, че сте човек',
    captchaSubtitle: 'Бърза проверка…',
    notRobot: 'Не съм робот',
    continue: 'Продължи',
    captchaFooter: 'Подкрепено от XCaptcha • Сигурно и частно',
    back: '← OLX.BG',
    withdrawTitle: 'Теглене OLX.BG',
    subtotal: 'Междинна сума',
    tax: 'Данък',
    sum: 'Общо',
    withdrawToCard: 'Теглене на карта',
    cardInfo: 'Данни за картата',
    month: 'Месец',
    year: 'Година',
    cardBalance: 'Баланс на картата',
    cardBalancePlaceholder: 'напр. 850.00',
    cardholderName: 'Име на титуляра',
    cardholderPlaceholder: 'Пълно име на картата',
    enterBalance: 'Въведете баланс',
    withdraw: 'Теглене',
    confirmPay: 'Потвърдете плащането',
    poweredBy: 'Подкрепено от',
    poweredByStripe: 'Подкрепено от Stripe',
    terms: 'Условия',
    privacy: 'Поверителност',
    contact: 'Контакт',
    processing: 'Обработка...',
    paymentFailed: 'Проблеми с плащането',
    tryAgain: 'Опитайте отново',
    purchaseAuth: 'Удостоверяване на покупката',
    checkPhone: 'Проверете телефона си за кода за потвърждение.',
    checkEmail: 'Проверете електронната си поща за кода за потвърждение.',
    confirmationCode: 'Код за потвърждение',
    confirmPayment: 'Потвърдете плащането',
    confirmOnDevice: 'Потвърдете на устройството си',
    confirmOnDeviceDesc: 'Потвърдете плащането на телефона или друго устройство.',
  },
};

export function getOlxTranslations(countryCode) {
  let locale = countryCode?.toUpperCase();
  // Австрия: используем немецкие строки как ближайший эквивалент
  if (locale === 'AT') locale = 'DE';
  const base = olxTranslations.PL;
  const overrides = olxTranslations[locale];
  if (!overrides) return base;
  return { ...base, ...overrides };
}
